// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface LocToken {
  value: string;
  isModified: boolean;
}
